import { Search as MagneticSearch, SearchProps } from "@magnetic/search";

interface Props extends SearchProps {}

export const Search = (props: Props) => {
  //@ts-ignore TODO figure out the cause of this error. input fields does something weird with props
  return <MagneticSearch {...props} />;
};
